module.exports = __webpack_public_path__ + "img/GAME_FINDSAMEPICTURE.2ae772b8.jpg";